import { MapInput } from 'media/views';
import 'acf/openstreetmap-field';
import 'acf/openstreetmap-conditions';
